import { render, staticRenderFns } from "./ContabilitaDocumentoRigheViewComponent.vue?vue&type=template&id=56964179"
import script from "./ContabilitaDocumentoRigheViewComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheViewComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheViewComponent.vue?vue&type=style&index=0&id=56964179&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports